<template>
  <div>

    <v-text-field label="انتخاب نقش کاربر" :value="manufacturer_name" dense
                  outlined readonly append-icon="mdi-crosshairs" class="cursor-pointer" @click="dialog = true"
                  ref="input" :error-messages="errors"/>

    <v-dialog v-model="dialog" scrollable max-width="800px">
      <v-card elevation="2" outlined :loading="loading">
        <v-card-title>انتخاب تعرفه</v-card-title>
        <v-divider></v-divider>

        <v-card-actions>
          <v-text-field label="جستجو" append-icon="mdi-magnify"
                        v-model="search" @change="fetch"
                        hide-details class="my-3"/>
        </v-card-actions>

        <v-list>
          <v-list-item @click="pick(x)" v-for="(x,i) in manufacturers.data" :key="i">
<!--            <v-list-item-avatar>-->
<!--              <v-avatar>-->
<!--                &lt;!&ndash;                <v-img :src="x.image || `${$config.baseURL}/image/noData.svg`"/>&ndash;&gt;-->
<!--                <v-list-item-title v-text="x.name"/>-->
<!--              </v-avatar>-->
<!--            </v-list-item-avatar>-->

            <v-list-item-content>
              <v-list-item-title v-text="x.name"/>
                          <v-list-item-subtitle v-text="price(persian(x.price))+' تومان'">
                          </v-list-item-subtitle>
            </v-list-item-content>



            <v-list-item-action v-if="x.id === value">
              <v-icon>mdi-check</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>
        <v-card-actions>
          <pagination :data="manufacturers.data" :visible="2" v-on:page="fetch"/>

          <v-spacer/>

          <v-btn color="primary" class="mr-auto" text @click="dialog = false">بستن</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import pagination from "@/view/pages/pickers/pagination";
import routePagination from "@/view/content/route-pagination";

export default {
  components: {pagination, routePagination},
  name: "rolePicker",

  props: ['value', 'errors'],

  model: {
    prop: 'value',
    event: 'manufacturersPicker'
  },

  computed: {
    manufacturer_name: function () {

      if (this.model === null) return "";
      return this.model.name;
    }
  },

  data: () => ({
    dialog: false,
    loading: false,
    search: null,
    manufacturers: [],
    data:{},
    model: null,
  }),

  watch: {
    value: function () {
      // this.findModel();
    }
  },

  created() {
    this.fetch();
    console.log(this.value);
    this.manufacturers.find(x => {
      console.log(x)
      if (x.id === this.value) {
        console.log(x);
        this.manufacturer_name = x.name;
      }
    });
  },

  methods: {
    fetch(page = 1) {
      this.requestApiGet('admin/roles' )
          .then(({data}) => {
            this.data=data
            this.manufacturers = data
          })
          .catch(({response}) => this.$root.$emit('errorToast', response.data.message))
          .finally(() => this.loading = false);


    },
    findModel() {
      if (this.value == null) return;

      this.loading = true;

      this.$api.get(`manufacturers/${this.value}`)
          .then(({data}) => this.model = data)
          .catch(({response}) => this.$root.$emit('errorToast', response.data.message))
          .finally(() => this.loading = false);
    },
    pick(x) {
      this.$emit('manufacturersPicker', x.id);
      this.model = x;
      this.dialog = false;
    }
  }
}
</script>

<style scoped>

</style>
